import { Component, OnDestroy } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';

import { DOCTORS } from '../../data/doctors.data';
import { Doctor, Specialty } from '../../data/models';
import { SPECIALTIES, SPECIALTY_ORDER } from '../../data/specialties.data';
import { SiteDoctor, SiteDoctorService } from '../../site-doctor.service';
import { SiteNavService } from '../../site-nav.service';

@Component({
  selector: 'ws-site-specialty',
  templateUrl: './specialty.component.html'
})
export class SiteSpecialtyComponent implements OnDestroy {
  specialty: Specialty;
  doctors: Doctor[] = [];
  dynamicDoctors: SiteDoctor[] = [];
  prev: Specialty;
  next: Specialty;

  private readonly sub: Subscription;

  constructor(nav: SiteNavService, doctorService: SiteDoctorService) {
    this.sub = combineLatest(nav.page$, doctorService.doctors$).subscribe(([page]) => {
      const s = SPECIALTIES.find(x => x.slug === page.slug);
      if (!s) { return; }
      const i = SPECIALTY_ORDER.indexOf(s.slug);
      this.specialty = s;
      this.doctors = s.doctors.map(slug => DOCTORS.find(d => d.slug === slug));
      this.dynamicDoctors = doctorService.forDepartmentName(s.name);
      this.prev = SPECIALTIES.find(x => x.slug === SPECIALTY_ORDER[(i + SPECIALTY_ORDER.length - 1) % SPECIALTY_ORDER.length]);
      this.next = SPECIALTIES.find(x => x.slug === SPECIALTY_ORDER[(i + 1) % SPECIALTY_ORDER.length]);
    });
  }

  ngOnDestroy() { this.sub.unsubscribe(); }

  detail(d: Doctor, label: string): string {
    const row = d.details.find(x => x[0] === label);
    return row ? row[1] : '';
  }
}
